import { render } from "./SubmitForm.vue?vue&type=template&id=67362e39&scoped=true"
import script from "./SubmitForm.vue?vue&type=script&lang=js"
export * from "./SubmitForm.vue?vue&type=script&lang=js"

import "./SubmitForm.vue?vue&type=style&index=0&id=67362e39&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67362e39"]])

export default __exports__